import {AuthEffect} from './auth.effect';
import {ShiftEffects} from '../../shifts/store/effects';
import {SettingsEffect} from '../../settings/store/effects/settings.effect';
import {FreelancerEffect} from '../../freelancers/store/effects/freelancer.effect';
import {ProfileEffect} from '../../profile/store/effects/profile.effect';
import {DashboardEffett} from '../../dashboard/store/effects/dashboard.effect';

export const effects = [
  AuthEffect,
  ...ShiftEffects,
  SettingsEffect,
  FreelancerEffect,
  ProfileEffect,
  DashboardEffett
];



// WEBPACK FOOTER //
// /Users/bitcot/Projects/PouredHQ/getpoured-popup-angular/src/app/store/effects/index.ts